import { useDispatch, useSelector } from "react-redux";
import { getProductListViewData } from "@scenes/searchResults/Utils";
import { useSortedTabletListData } from "./useSortCustomData";
import {
  setMultipleColumnWidths,
  useUserInfo,
} from "@redux/slices/userInfoSlice";
import { useEffect } from "react";
import { SearchFilterTypeEnum } from "@components/atoms/Filters/utils";
import { ProductCategory } from "@utils/constants";

export const useColumnWidths = (
  productType: ProductCategory,
  priceMode: number,
  sectionName: SearchFilterTypeEnum = SearchFilterTypeEnum.SINGLE_STONES
) => {
  const reduxColumnWidth = useSelector(
    (state: any) => state.userInfo.columnWidths
  );
  const userInfo = useUserInfo();
  const userPriceMode = userInfo?.user?.price_mode ?? priceMode;
  const dispatch = useDispatch();
  const productListViewData = getProductListViewData(productType);
  const defaultListDataOptions = useSortedTabletListData(
    productType,
    userPriceMode,
    sectionName,
    false
  );

  const listDataOptions =
    productListViewData && productListViewData.length > 0
      ? productListViewData
      : defaultListDataOptions;

  const storageKey = `${productType}_${sectionName}`;

  useEffect(() => {
    if (!reduxColumnWidth?.[storageKey]?.[priceMode]) {
      const widths: { [key: string]: number } = {};

      listDataOptions?.forEach((item) => {
        if (item?.name && item.response_key && item.deafult_width) {
          const width = parseInt(item.deafult_width.split("px")[0], 10);
          if (!isNaN(width)) {
            widths[item.name] = width;
          }
        }
      });

      if (Object.keys(widths).length > 0) {
        dispatch(
          setMultipleColumnWidths({
            productType: storageKey,
            priceMode,
            widths,
          })
        );
      }
    }
  }, [storageKey, priceMode, listDataOptions, dispatch, reduxColumnWidth]);

  const buildDefaultColumnWidths = (options: any[]) => {
    const defaultWidths: { [key: string]: number } = {};
    options?.forEach((item) => {
      if (item.name && item.response_key && item.deafult_width) {
        const width = parseInt(item.deafult_width.split("px")[0], 10);
        if (!isNaN(width)) {
          defaultWidths[item.name] = width;
        }
      }
    });
    return defaultWidths;
  };

  const columnWidths =
    reduxColumnWidth?.[storageKey]?.[priceMode] ??
    buildDefaultColumnWidths(listDataOptions);

  return columnWidths;
};
